__turbopack_context__.v({
  "badge": "SignalBadge-module-scss-module__osoIlW__badge",
  "cancelled": "SignalBadge-module-scss-module__osoIlW__cancelled",
  "eventEnded": "SignalBadge-module-scss-module__osoIlW__eventEnded",
  "postponed": "SignalBadge-module-scss-module__osoIlW__postponed",
  "soldOut": "SignalBadge-module-scss-module__osoIlW__soldOut",
});
